module.exports = __webpack_public_path__ + "media/images/front/top/top_btn_2-b9925f1abdf7bdd7e1ec8ed71bbab89d.svg";